'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./FlexCenter.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FlexCenter = function FlexCenter(_ref) {
    var children = _ref.children,
        className = _ref.className;
    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('FlexCenter', className) },
        _react2.default.createElement(
            'div',
            { className: 'flex-center-content' },
            children
        )
    );
};

FlexCenter.propTypes = {
    children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.array, _propTypes2.default.string]),
    className: _propTypes2.default.string
};

exports.default = FlexCenter;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/misc/FlexCenter.js
// module id = 198
// module chunks = 0